<template>
  <div class="storeClose w w1200">
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家关店申请</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <el-steps :active="activeIndex" align-center>
        <el-step title="申请关店"></el-step>
        <el-step title="申请审核"></el-step>
        <el-step title="保证金退款"></el-step>
        <el-step title="关店完成"></el-step>
      </el-steps>
      <div class="step-section step-one" v-if="activeIndex === 1">
        <div class="title">店铺基本信息</div>
        <div class="store-data" v-if="applyStoreData">
          <div class="cell flex-start-center">
            <div class="cell-label">店铺名称：</div>
            <div class="cell-value">{{applyStoreData.merchant.name}}</div>
          </div>
          <div class="cell flex-start-center">
            <div class="cell-label">店铺类别：</div>
            <div class="cell-value">{{applyStoreData.merchantSortName}}</div>
          </div>
          <div class="cell flex-start-center">
            <div class="cell-label">店铺等级：</div>
            <div class="cell-value">{{applyStoreData.levelName}}</div>
          </div>
          <div class="cell flex-start-center">
            <div class="cell-label">公司名称：</div>
            <div class="cell-value">{{applyStoreData.merchant.companyName}}</div>
          </div>
          <div class="cell flex-start-center">
            <div class="cell-label">管理人手机：</div>
            <div class="cell-value">{{applyStoreData.merchant.phone}}</div>
          </div>
        </div>
        <div class="attention">
          <div>关店注意事项</div>
          <div>1、尽快处理未完成订单或售后订单。</div>
          <div>2、申请关店中需要进行90天关店公示，将在店铺首页显著位置展示"停业"标志。</div>
          <div>3、完成关店流程后，店铺将不可继续经营。</div>
        </div>
        <div class="btn-box">
          <el-button type="primary" block @click="showDialog">确定申请</el-button>
        </div>
      </div>
      <div class="step-section step-two" v-else>
        <div class="state">
          <i class="regicon" :class="stateMap[applyStoreData.merchantStatus].icon"></i>
          <div class="state-text">{{stateMap[applyStoreData.merchantStatus].text}}</div>
        </div>
        <div class="memo" v-if="applyStoreData.merchantStatus === 'AUDIT_ERR'">
          <div class="memo-label">拒绝原因:</div>
          <div class="memo-text">{{shutMemo}}</div>
        </div>
        <div class="btn-box" style="margin-top: 40rpx">
          <el-button type="primary" v-if="applyStoreData.merchantStatus === 'AUDIT_ERR'" @click="doApplyAgain">重新申请</el-button>
          <div style="margin-top: 10px;">
            <el-link @click="closeStoreUndo"
                     v-if="applyStoreData.merchantStatus === 'APPLY' || applyStoreData.merchantStatus === 'AUDIT_ERR'">
              <i class="el-icon-refresh-left"></i>
              <span>撤销申请</span>
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="关店申请"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleClose">
      <div class="content">
        <div class="tips">
          <i class="el-icon-info"></i>
          <span>关店申请完成后，店铺将不可经营，请谨慎操作！</span>
        </div>
        <div class="textarea">
          <div class="text-label">关店申请备注</div>
          <div class="textarea-inner">
            <el-input v-model="applyMemo" type="textarea" placeholder="请输入" maxlength="140"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="closeStoreFetch">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {fetchUndoStoreClose, fetchApplyStoreClose} from '../../api/xunyou';
export default {
  name: 'storeClose',
  data() {
    return {
      applyAgain: false,
      loading: false,
      dialogVisible: false,
      applyMemo: '',
      stateMap: {
        'APPLY': {
          icon: 'el-icon-timer',
          text: '关店申请平台审核中...'
        },
        'AUDIT_ERR': {
          icon: 'el-icon-circle-close',
          text: '申请审核失败'
        },
        'PUBLICITY': {
          icon: 'el-icon-data-board',
          text: '关店申请审核通过，店铺将进入90天关店公示期，公示期结束将自动进入保证金退款流程，请耐心等待！'
        },
        'WAIT_REFUND': {
          icon: 'el-icon-refresh-left',
          text: '保证金退款处理中，预计1-3个工作日处理完成'
        },
        'CLOSE': {
          icon: 'el-icon-finished',
          text: '店铺已关闭'
        },
        'CLOSE_REG': {
          icon: 'el-icon-finished',
          text: '店铺已被强制关闭，请联系平台客服处理'
        }
      }
    }
  },
  computed: {
    activeIndex () {
      let index = 1;
      if  (!this.applyStoreData || this.applyAgain) return index;
      if (this.applyStoreData.merchantStatus === 'APPLY'
        || this.applyStoreData.merchantStatus === 'AUDIT_ERR'
        || this.applyStoreData.merchantStatus === 'PUBLICITY') {
        index = 2;
      }
      if (this.applyStoreData.merchantStatus === 'WAIT_REFUND') {
        index = 3;
      }
      if (this.applyStoreData.merchantStatus === 'CLOSE' || this.applyStoreData.merchantStatus === 'CLOSE_REG') {
        index = 4;
      }
      return index;
    },
    applyStoreData () {
      return this.$store.state.applyStoreData;
    },
    shutMemo () {
      return this.applyStoreData.shutFlow && this.applyStoreData.shutFlow.shutMemo;
    }
  },
  created () {},
  methods: {
    handleClose (done) {
      this.applyMemo = '';
      done();
    },
    showDialog () {
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.applyMemo = '';
    },
    doApplyAgain () {
      this.applyAgain = true;
    },
    closeStoreFetch () {
      if (!this.applyMemo) {
        this.$message.warning('请输入关店申请备注');
        return ;
      }
      const params = {
        bxmId: this.applyStoreData.bxmId,
        applyMemo: this.applyMemo
      }
      this.loading = true;
      fetchApplyStoreClose(params)
        .then(res => {
          console.log('关店申请结果:', res);
          if (res.code === 0) {
            this.applyAgain = false;
            this.$store.dispatch('getStoreData');
            this.hideDialog();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.error('错误：', err);
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeStoreUndo () {
      this.loading = true;
      fetchUndoStoreClose({bxmId: this.applyStoreData.bxmId})
        .then(res => {
          console.log('关店撤销结果:', res);
          if (res.code === 0) {
            this.$message.success('申请已撤销');
            this.$store.dispatch('getStoreData');
            this.$router.back();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.error('错误：', err);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.page-content{
  padding: 30px 15px;
  min-height: 70vh;
  border-radius: 5px;
  background-color: #fff;
}
.title{
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0;
}
.step-section{
  padding: 20px 0;
  .state{
    margin-top: 30px;
    text-align: center;
  }
  .regicon{
    font-size: 6em;
  }
  .state-text{
    font-size: 28px;
    width: 600px;
    margin: 0 auto;
  }
}
.step-one{
  width: 500px;
  margin: 0 auto;
  .store-data{
    background-color: #f2f6fd;
    padding: 10px;
    font-size: 14px;
    border-radius: 10px;
    .cell{
      padding: 4px 0;
      .cell-label{
        display: inline-block;
        width: 100px;
        color: #888888;
      }
      .cell-value{
        display: inline-block;
      }
    }
  }
  .attention{
    font-size: 12px;
    color: #999999;
    padding: 20px 0;
  }
}
.btn-box{
  padding: 20px;
  text-align: center;
}
.tips{
  color: #ff8f39;
  margin-bottom: 20px;
}
.memo{
  width: 660px;
  margin: 20px auto;
  padding: 10px;
  color: #999999;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid #ffae6f;
  background-color: #ffa1513b;
  .memo-label{
    font-weight: 500;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/storeClose.vue